/* SLXY theme JS
   ------------------------------------------------------------------
   - Cart: real Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js)
   - Wishlist: localStorage only (Shopify has no native wishlist)
   - Account: link-outs to Shopify's native account routes (works with
     both classic and new customer accounts) + tab switching for the
     logged-in profile/orders panes
   - Quiz: reads real, tagged product data injected by the
     newsletter-quiz section
------------------------------------------------------------------- */

(function () {
  /* ---------- money formatting (Shopify's standard algorithm) ---------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  window.formatMoney = function (cents, format) {
    var formatString = format || window.themeMoneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };

  /* ---------- generic drawer open/close ---------- */
  function wireDrawer(btnId, drawerId, bgId) {
    var btn = document.getElementById(btnId);
    var drawer = document.getElementById(drawerId);
    var bg = document.getElementById(bgId);
    if (!btn || !drawer || !bg) return;
    function open() { drawer.classList.add('open'); bg.classList.add('open'); }
    function close() { drawer.classList.remove('open'); bg.classList.remove('open'); }
    btn.addEventListener('click', open);
    bg.addEventListener('click', close);
    drawer.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
  }
  function openDrawer(drawerId, bgId) {
    var drawer = document.getElementById(drawerId);
    var bg = document.getElementById(bgId);
    if (drawer) drawer.classList.add('open');
    if (bg) bg.classList.add('open');
  }
  wireDrawer('wishlistBtn', 'wishlistDrawer', 'wishlistBg');
  wireDrawer('cartBtn', 'cartDrawer', 'cartBg');

  /* ---------- cart (real Shopify Ajax API) ---------- */
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function renderCartBody(cart) {
    var badge = document.getElementById('cartBadge');
    if (badge) badge.textContent = cart.item_count ? cart.item_count : '';
    var body = document.getElementById('cartBody');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer-empty">Your bag is empty.</p>';
    } else {
      body.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">' : '';
        return '<div class="drawer-item" data-line-key="' + item.key + '">' +
          '<div class="prod-img">' + img + '</div>' +
          '<div class="drawer-item-copy">' +
          '<span class="prod-name">' + item.product_title + '</span>' +
          '<span class="drawer-qty">Qty ' + item.quantity + '</span>' +
          '<span class="prod-price">' + window.formatMoney(item.final_line_price) + '</span>' +
          '<button class="drawer-item-remove" data-remove-cart="' + item.key + '">Remove</button>' +
          '</div></div>';
      }).join('');
      body.querySelectorAll('[data-remove-cart]').forEach(function (btn) {
        btn.addEventListener('click', function () { changeCartLine(btn.dataset.removeCart, 0); });
      });
    }
    var subtotalEl = document.getElementById('cartSubtotal');
    if (subtotalEl) subtotalEl.textContent = window.formatMoney(cart.total_price);
  }

  function refreshCart() {
    return fetchCart().then(renderCartBody);
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (err) { throw err; }); }
      return r.json();
    }).then(function () {
      if (btn) {
        var original = btn.textContent;
        btn.textContent = 'Added ✓';
        btn.classList.add('added');
        setTimeout(function () { btn.textContent = original; btn.classList.remove('added'); }, 1200);
      }
      return refreshCart();
    }).then(function () {
      openDrawer('cartDrawer', 'cartBg');
    }).catch(function (err) {
      alert((err && err.description) || 'Sorry, that item could not be added to your bag.');
    });
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCartBody);
  }

  document.querySelectorAll('.add-to-bag').forEach(function (btn) {
    if (btn.disabled) return;
    btn.addEventListener('click', function () { addToCart(btn.dataset.variantId, btn); });
  });
  refreshCart();

  /* ---------- wishlist (localStorage — Shopify has no native equivalent) ---------- */
  (function () {
    var wishlist = [];
    try { wishlist = JSON.parse(localStorage.getItem('slxy_wishlist') || '[]'); } catch (e) { wishlist = []; }

    function saveWishlist() {
      try { localStorage.setItem('slxy_wishlist', JSON.stringify(wishlist)); } catch (e) { /* storage unavailable */ }
    }

    function syncHeartButtons() {
      document.querySelectorAll('.heart-toggle').forEach(function (btn) {
        var isSaved = wishlist.some(function (i) { return i.id === btn.dataset.id; });
        btn.classList.toggle('saved', isSaved);
      });
    }

    function renderWishlist() {
      var badge = document.getElementById('wishlistBadge');
      if (badge) badge.textContent = wishlist.length ? wishlist.length : '';
      var body = document.getElementById('wishlistBody');
      if (!body) return;
      if (!wishlist.length) {
        body.innerHTML = '<p class="drawer-empty">Nothing saved yet — tap the heart on any product to add it here.</p>';
        return;
      }
      body.innerHTML = wishlist.map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="' + item.name + '">' : '';
        return '<div class="drawer-item">' +
          '<div class="prod-img">' + img + '</div>' +
          '<div class="drawer-item-copy">' +
          '<a href="' + item.url + '"><span class="prod-name">' + item.name + '</span></a>' +
          '<span class="prod-price">' + item.price + '</span>' +
          '<button class="drawer-item-remove" data-remove-wish="' + item.id + '">Remove</button>' +
          '</div></div>';
      }).join('');
      body.querySelectorAll('[data-remove-wish]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wishlist = wishlist.filter(function (i) { return i.id !== btn.dataset.removeWish; });
          syncHeartButtons(); saveWishlist(); renderWishlist();
        });
      });
    }

    document.querySelectorAll('.heart-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.id;
        var exists = wishlist.some(function (i) { return i.id === id; });
        if (exists) {
          wishlist = wishlist.filter(function (i) { return i.id !== id; });
        } else {
          wishlist.push({ id: id, name: btn.dataset.name, price: btn.dataset.price, image: btn.dataset.image, url: btn.dataset.url });
        }
        syncHeartButtons(); saveWishlist(); renderWishlist();
      });
    });

    syncHeartButtons();
    renderWishlist();
  })();

  /* ---------- account modal (tabs only — sign in/up are real links) ---------- */
  (function () {
    var overlay = document.getElementById('accountOverlay');
    var btn = document.getElementById('accountBtn');
    var closeBtn = document.getElementById('accountClose');
    if (!overlay || !btn) return;
    btn.addEventListener('click', function () { overlay.classList.add('open'); });
    if (closeBtn) closeBtn.addEventListener('click', function () { overlay.classList.remove('open'); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.classList.remove('open'); });
    overlay.querySelectorAll('.account-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        overlay.querySelectorAll('.account-tab').forEach(function (t) { t.classList.remove('active'); });
        overlay.querySelectorAll('.account-pane').forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var pane = overlay.querySelector('.account-pane[data-pane="' + tab.dataset.tab + '"]');
        if (pane) pane.classList.add('active');
      });
    });
  })();

  /* ---------- mobile nav toggle ---------- */
  (function () {
    var navToggle = document.querySelector('.nav-toggle');
    var navLinks = document.querySelector('.nav-links');
    if (!navToggle || !navLinks) return;
    navToggle.addEventListener('click', function () {
      var isOpen = navLinks.style.display === 'flex';
      navLinks.style.cssText = isOpen
        ? ''
        : 'display:flex; position:absolute; top:100%; left:0; right:0; flex-direction:column; gap:0; background:var(--ivory); padding:1rem 1.5rem 1.5rem; border-top:1px solid rgba(14,11,10,0.08); z-index:19;';
      navLinks.querySelectorAll('a').forEach(function (a) { a.style.padding = isOpen ? '' : '0.8rem 0'; });
      navToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  })();

  /* ---------- quiz (reads real product data from the newsletter-quiz section) ---------- */
  (function () {
    var overlay = document.getElementById('quizOverlay');
    if (!overlay) return;
    var openBtn = document.getElementById('openQuiz');
    var closeBtn = document.getElementById('quizClose');
    var restartBtn = document.getElementById('quizRestart');
    var steps = overlay.querySelectorAll('.quiz-step');
    var progress = overlay.querySelectorAll('.quiz-progress span');
    var resultsEl = document.getElementById('quizResults');
    var headlineEl = document.getElementById('quizResultHeadline');

    var answers = {};
    var catalog = [];
    var catalogEl = document.getElementById('quizCatalogData');
    if (catalogEl) {
      try { catalog = JSON.parse(catalogEl.textContent); } catch (e) { catalog = []; }
    }

    function showStep(key) {
      steps.forEach(function (s) { s.classList.toggle('active', s.dataset.step === key); });
      var order = ['1', '2', '3', 'result'];
      var idx = order.indexOf(key);
      progress.forEach(function (p, i) { p.classList.toggle('done', i < idx || key === 'result'); });
    }

    function openQuiz() { answers = {}; showStep('1'); overlay.classList.add('open'); }
    function closeQuiz() { overlay.classList.remove('open'); }

    if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); openQuiz(); });
    if (closeBtn) closeBtn.addEventListener('click', closeQuiz);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuiz(); });
    if (restartBtn) restartBtn.addEventListener('click', openQuiz);

    overlay.querySelectorAll('.quiz-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parts = btn.dataset.answer.split(':');
        answers[parts[0]] = parts[1];
        var currentStep = btn.closest('.quiz-step').dataset.step;
        if (currentStep === '1') showStep('2');
        else if (currentStep === '2') showStep('3');
        else if (currentStep === '3') renderResults();
      });
    });

    function renderResults() {
      var wanted = [answers.focus, answers.type, answers.goal].filter(Boolean);
      var scored = catalog.map(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        var score = wanted.filter(function (w) { return tags.indexOf(w) !== -1; }).length;
        return Object.assign({ score: score }, p);
      }).sort(function (a, b) { return b.score - a.score; });

      var top = scored.slice(0, 3);
      if (headlineEl) headlineEl.textContent = 'Picked for your ' + (answers.focus || 'routine');
      if (!resultsEl) return;
      if (!top.length) {
        resultsEl.innerHTML = '<p class="drawer-empty">Add and tag products in the quiz collection to see picks here.</p>';
      } else {
        resultsEl.innerHTML = top.map(function (p) {
          var img = p.image ? '<img src="' + p.image + '" alt="' + p.name + '">' : '';
          return '<div class="quiz-result-item">' +
            '<div class="prod-img">' + img + '</div>' +
            '<div class="quiz-result-copy">' +
            '<a href="' + p.url + '"><span class="prod-name">' + p.name + '</span></a>' +
            '<span class="prod-price">' + p.price + '</span>' +
            '</div></div>';
        }).join('');
      }
      showStep('result');
    }
  })();
})();
